<template>
  <div>
    <Header></Header>
    <router-view class="minHight"></router-view>
    <Footer v-if="routerName!='/helpCenter'"></Footer>

    <!-- 回到顶部 -->
    <!-- <div v-show="scrollBtn" @click="toTop" class="goTopBtn">
      <i class="el-icon-upload2"></i>
    </div> -->

    <!-- 旧右边浮动框 -->
    <!-- <div class="fukuang">
      <div class="fukuang-item">
        <img @click="tipsText" style="border-radius: 50%;" src="../../assets/images/kefu.png" width="90%" alt="" srcset="">
      </div>
      <div class="fukuang-item">
        <el-popover placement="left" class="w120" trigger="hover">
          <div class="fukScan-box">
            <img class="w120" src="../../assets/images/scanwx.png" alt="" srcset="">
            <p>新人注册</p>
            <p>下单领取<span style="color:#ffb37b">100</span>元随机红包</p>
          </div>

          <div slot="reference" class="w70" style="height:100%;text-align: center;">
            <img class="w27" src="../../assets/images/scanFu.png" alt="" srcset="" />
          </div>
        </el-popover>
      </div>
      <div class="fukuang-item">
        <el-popover placement="left" class="w240" trigger="hover">
          <div class="share-warpper">
            <div @click="shareXinLang">
              <svg-icon :size="20" color="#fff" name="xinlang"></svg-icon>
            </div>
            <div @click="shareQqkj">
              <svg-icon :size="22" color="#fff" name="qqkj"></svg-icon>
            </div>
            <div @click="shareCopy" class="copy1">
              <svg-icon :size="20" color="#fff" name="txwb"></svg-icon>
            </div>
            <div @click="shareQq">
              <svg-icon :size="26" color="#e74d3d" name="qq"></svg-icon>
            </div>
            <div @click="shareCopy">
              <svg-icon :size="26" color="#fff" name="renren"></svg-icon>
            </div>
            <div @click="shareCopy">
              <svg-icon :size="26" color="#7bd071" name="wxchat"></svg-icon>
            </div>
          </div>

          <div slot="reference" class="w70" style="height:100%;text-align: center;">
            <img class="w26" src="../../assets/images/share.png" alt="" srcset="">
          </div>
        </el-popover>
      </div>
    </div> -->
    <!-- 新浮动框 -->
    <div class="fudong-box" v-show="scrollBtn">
      <div class="fudongOne" :class="[ind<1?'act':'',(ind>0&&ind<4)?'bor-css':'']" @click="selectFun(item)" v-for="(item,ind) in fudongList">
        <img class="fudongimg"  :src="item.img" />
        <img class="fudongimg1"  :src="item.img1" />
        <div class="fudongname">{{ item.name }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "./header.vue";
import Footer from "./footer.vue";
export default {
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      scrollBtn: false,
      routerName:'',
      fudongList:[{
        name:'在线咨询',
        img:require("../../assets/images/fudong1.png"),
        img1:require("../../assets/images/fudong1.png"),
      },{
        name:'咨询热点',
        img:require("../../assets/images/fudong2.png"),
        img1:require("../../assets/images/p12.png"),
      },{
        name:'扫码咨询',
        img:require("../../assets/images/fudong3.png"),
        img1:require("../../assets/images/p13.png"),
      },{
        name:'免费体检',
        img:require("../../assets/images/fudong4.png"),
        img1:require("../../assets/images/p14.png"),
      },{
        name:'',
        img:require("../../assets/images/fudong5.png"),
        img1:require("../../assets/images/p15.png"),
      }],
    };
  },
  watch:{
	  $route(to,from){
      // console.log(from.path);//从哪来
      console.log(to.path);//到哪去
      this.routerName = to.path
    }
  },
  created(){
  },
  methods: {
    selectFun(row){
      if(row.name==''){
        this.toTop()
      }
    },
    tipsText(){
      this.$message("即将开通，尽请期待。")
    },
    toTop() {
      var timer = setInterval(function () {
        let osTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        let ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          osTop + ispeed;
        this.isTop = true;
        if (osTop === 0) {
          clearInterval(timer);
        }
      }, 30);
    },
    shareXinLang(event) {
      event.preventDefault();
      // shareUrl是微博的分享地址，（有资料说需要真实的appkey，必选参数，这里我没用appkey也可以正常分享）
      var _shareUrl = "http://service.weibo.com/share/share.php?";
      _shareUrl += "url=" + encodeURIComponent(window.location.href); //参数url设置分享的内容链接
      _shareUrl += "&title=" + encodeURIComponent("意约官网"); //参数title设置分享的标题
      // 保留当前页面,打开一个非tab页面（按需求来，可以新开标签页，也可以在当前页新开页面）
      window.open(
        _shareUrl,
        "_blank",
        "height=500, width=800",
        "scrollbars=yes,resizable=1,modal=false,alwaysRaised=yes"
      );
    },
    shareQqkj() {
      var shareUrl = `http://connect.qq.com/widget/shareqq/index.html?url=${window.location.href}&sharesource=qzone&title=你的分享标题&pics=你的分享图片地址&summary=你的分享描述&desc=你的分享简述`;
      window.open(
        shareUrl,
        "newwindow",
        "height=500, width=800,top=100,left=100"
      );
    },
    // shareTxwb(){//腾讯微博
    //   // var shareqqstring='http://v.t.qq.com/share/share.php?title=意约官网&url='+window.location.href;
    //   // window.open(shareqqstring,'newwindow','height=500,width=800,top=100,left=100');
    //   var clipboard = new Clipboard('.copy1');
    // },
    shareQq() {
      //QQ好友 可分享
      var shareUrl = `http://connect.qq.com/widget/shareqq/index.html?url=${window.location.href}&sharesource=qzone&title=你的分享标题&pics=你的分享图片地址&summary=你的分享描述&desc=你的分享简述`;
      window.open(
        shareUrl,
        "newwindow",
        "height=500, width=800,top=100,left=100"
      );
    },

    shareCopy() {
      // var clipboard = new Clipboard('.copy3');
      let oInput = document.createElement("input");
      //这边为链接地址this.liveLink='www.baidu.com'
      oInput.value = window.location.href;
      document.body.appendChild(oInput);
      oInput.select();
      console.log(oInput.value);
      document.execCommand("Copy");
      oInput.remove();
      this.$message({
        message: "复制成功",
        type: "success",
      });
    }
  },
  mounted() {
    let that = this;
    this.$nextTick(function () {
      window.addEventListener(
        "scroll",
        function () {
          if (document.documentElement.scrollTop > 100) {
            that.scrollBtn = true;
          } else {
            that.scrollBtn = false;
          }
        },
        true
      );
    });
  },
};
</script>

<style lang="less" scoped>
.goTopBtn {
  position: fixed;
  right: 20px;
  bottom: 100px;
  width: 50px;
  height: 50px;
  background: #fff;
  border-radius: 50%;
  text-align: center;
  line-height: 50px;
  font-size: 20px;
  color: #ff9141;
  box-shadow: 0px 5px 24px 0px rgba(255 145 65 / 50%);
  cursor: pointer;
  z-index: 1000;
}
.minHeight{
  min-height:calc(100vh - 140px)
}

.fukuang {
  width: 70px;
  height: 210px;
  background: #ffffff;
  box-shadow: 0px 5px 30px 0px rgba(255, 137, 51, 0.4);
  border-radius: 35px;
  position: fixed;
  right: 20px;
  top: 50%;
  z-index: 1000;
  margin-top: -105px;

  & > .fukuang-item {
    height: 69px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  & > .fukuang-item:not(:last-child) {
    border-bottom: 1px solid #e3e3e3;
  }
}
.share-warpper {
  height: 30px;
  & > div {
    float: left;
    width: 30px;
    height: 30px;
    border-radius: 3px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  & > div:not(:first-child) {
    margin-left: 10px;
  }
  & > div:nth-child(1) {
    background: #f78585;
  }
  & > div:nth-child(2) {
    background: #fac341;
  }
  & > div:nth-child(3) {
    background: #28ccbf;
  }
  & > div:nth-child(4) {
    background: #e74d3d;
  }
  & > div:nth-child(5) {
    background: #94b3eb;
  }
  & > div:nth-child(6) {
    background: #7bd071;
  }
}
.fukScan-box {
  text-align: center;
  & > p:nth-child(2) {
    line-height: 14px;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #000000;
    margin: 12px 0 10px 0;
  }
  & > p:nth-child(3) {
    line-height: 12px;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #666666;
  }
}

.fudong-box{
  width: 66px;
  height: 340px;
  position: fixed;
  right: 0;
  top: 300px;
  background: #FFFFFF;
  box-shadow: -2px 2px 20px 0px rgba(0,0,0,0.08);
  filter: blur(0px);
}
.fudongOne{
  width: 100%;
  height: 68px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #000000;
}
// .fudongOne:hover{
//   background: #FF6701;
// }
.act{
  background: #FF6701;
  color: #fff!important;
}
.bor-css{
  border-bottom: 1px solid #eee;
}
.fudongimg{
  width: 25px;
  height: 25px;
}
.fudongimg1{
  width: 25px;
  height: 25px;
  display: none;
}
.fudongOne:hover .fudongimg{
  display: none;
}
.fudongOne:hover .fudongimg1{
  display: inline-block;
}
.fudongOne:hover{
  background: #FF6701;
  color: #fff;
}
.fudongname{
  font-size: 12px;
  margin-top: 8px;
}

.w140{
  width: 140px
}
.w25{
  width: 25px
} 
.mr16{
  margin-right: 16px
}
.mt48{
  margin-top:48px
}
.mt34{
  margin-top:34px
}
.mt44{
  margin-top:44px
}
.mt72{margin-top: 72px}
.mt56{margin-top:56px}
.mt55{margin-top:55px}
.mt23{margin-top:23px}
.h86{height:86px}
.w70{width:70px}
.w71{width:71px}
.w76{width:76px}
.w77{width:77px}
.w81{width:81px}
.w120{width:120px}
.w102{width:102px}
.w26{width:26px}
.w27{width:27px}
.w30{width:30px}
.w240{width:240px}
.h55{height:55px}
.h102{height:102px}
</style>